// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import './utils/axios'
import './utils/validate'
import {required, num} from "@/utils/validate";
import ElementUI from 'element-ui'; // 2.1引入结构
import 'element-ui/lib/theme-chalk/index.css'; // 2.2引入样式
import Layout from './components/Layout.vue';
import moblieHome from './view/moblieHome.vue';
import { Button } from "element-ui";
import "./element.js";
import './assets/style.css';

// 全局注册saas弹窗组件
import Saas from '@/components/Saas.vue'
Vue.component('Saas', Saas);

import StoreImg from '@/components/StoreImg.vue'
Vue.component('StoreImg', StoreImg);

import Service from '@/components/Service.vue'
Vue.component('Service', Service);


//设置反向代理，前端请求默认发送到 http://前端ip地址:你的前端端口/api
// var axios = require('axios')
// axios.defaults.baseURL = '/api'
function isMobile() {
	let flag = navigator.userAgent.match(
		/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
	)
	return flag
}
//全局配置请求
import util from './utils/util.js'
Vue.prototype.util = util

Vue.config.productionTip = false
Vue.use(ElementUI); // 3.安装
/* eslint-disable no-new */
if (isMobile()) {
	new Vue({
	  el: '#app',
	  router,
	  render: h => h(moblieHome)
	});
} else {
	new Vue({
	  el: '#app',
	  router,
	  render: h => h(Layout)
	});
}



// WEBPACK FOOTER //
// ./src/main.js